import {entryUpdateMessageHandler} from 'notebook/realtime/messageHandlers/entryUpdateMessageHandler';
import {lockUpdateMessageHandler} from 'notebook/realtime/messageHandlers/lockUpdateMessageHandler';
import {tableApiPendingRowsUpdateMessageHandler} from 'notebook/realtime/messageHandlers/tableApiPendingRowsUpdateMessageHandler';
import {RealtimeMessageType} from 'realtime/Constants';
import {GetRealtimeMessageData, RealtimeMessage} from 'realtime/RealtimeChannel';

export interface DocumentUpdateMessageHandler<Name extends RealtimeMessageType> {
  active?: (fileId: string, data: GetRealtimeMessageData<Name>) => void;
  inactive?: (fileId: string, data: GetRealtimeMessageData<Name>) => void;
}

// Mapped object that preserves the specific type for each handler
const messageHandlers: {[K in RealtimeMessageType]?: DocumentUpdateMessageHandler<K>} = {
  [RealtimeMessageType.ENTRY_UPDATE]: entryUpdateMessageHandler,
  [RealtimeMessageType.LOCK_UPDATE]: lockUpdateMessageHandler,
  [RealtimeMessageType.TABLE_API_PENDING_ROWS_UPDATE]: tableApiPendingRowsUpdateMessageHandler,
};

/**
 * Maps a message to its handler.
 */
export function messageRouter(fileId: string, type: 'active' | 'inactive'): (msg: RealtimeMessage) => void {
  return ({name, data}) => {
    const handler = getMessageHandler(name);
    if (handler[type]) {
      handler[type](fileId, data ?? {});
    }
  };
}

function getMessageHandler<T extends RealtimeMessageType>(type: T): DocumentUpdateMessageHandler<T> {
  // The mapped object ensures type safety - each handler is correctly typed for its message
  // Some messages are filtered out by this channel listener, so we return an empty object as fallback
  return messageHandlers[type] ?? {};
}
